import {
  snakeStore,
  SORT_COLUMN,
  SORT_DIRECTION,
  PER_PAGE
} from '@app/plugins/vuex-async-pagginate';
import { NotificationService } from '@notify/services/NotificationService';

export default snakeStore({
  state: {
    new_count: 0,
    [PER_PAGE]: 10,
    [SORT_COLUMN]: 'created_at',
    [SORT_DIRECTION]: 'desc'
  },

  actions: {
    getData: (_, params) => NotificationService.getList(params),

    readAllServer: () => NotificationService.readAll(),
    readAllLocal: ({ getters, commit }) => {
      const data = (getters['data'] || []).map(i => ({ ...i, is_received: true }));
      commit('data', data);
    },

    readAll: async ({ dispatch }) => {
      await dispatch('readAllServer');
      await dispatch('readAllLocal');
    },

    readOne: ({ getters, commit }, id) => {
      const data = getters['data'] || [];
      const index = data.findIndex(item => item.id === id);
      if (index > -1) {
        data[index].is_received = true;
        commit('data', data);
        NotificationService.read(id);
      }
    }
  }
});
